import React from "react";
import { Button, Icon, Modal } from "semantic-ui-react";
import Wave2 from "../../../images/modalWave2.svg";
import './ConfirmArchiveModal.scss';

export type ConfirmArchiveProps = {

    icon: string; // icon to display example for trash can
    confirmArchiveFunc: Function; // delete function you will pass the itemToArchive to
    displayName: string; // name to display in the modal
    itemToArchive: any; // Send this to confirmArchiveFunc on delete
    theme?: string; // primary secondary tertiary white
}

export const ConfirmArchiveModal: any = (props: ConfirmArchiveProps) => {

    const [open, setOpen] = React.useState(false);

    const archiveAndClose = () => {

        props.confirmArchiveFunc(props.itemToArchive);
        setOpen(false);
    }

    return (
            <Modal className="confirm-archive-modal"
                size="tiny"
                centered={true}
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                trigger={<Icon className={`${props.icon} ${props.theme} trash-icon`} name="trash" />}
            >
                <Modal.Header>Are you sure you want to archive this file?</Modal.Header>
                <Modal.Content>{props.displayName}</Modal.Content>

                <Modal.Actions>
                <div className="wave-div">
                    <img src={Wave2} alt="wave" className="wave" />
                </div>
                <div className="modal-btns">
                    <Button color="red" onClick={() => archiveAndClose()}>Archive</Button>
                    <Button color="grey" onClick={() => setOpen(false)}>Cancel</Button>
                </div>
                </Modal.Actions>
            </Modal>
    )
}